import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

Sentry.init({
  dsn: import.meta.env.VITE_REACT_APP_SENTRY_DSN,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error'], // Specify log levels to capture
    }),
  ],

  // Filter out unwanted errors to save quota
  beforeSend(event) {
    // Filter out load failed errors
    if (event.exception?.values?.[0]?.value?.includes('Load failed')) {
      return null;
    }

    // Filter out TypeError related to fetch/network issues
    if (
      event.exception?.values?.[0]?.type === 'TypeError' &&
      (event.exception?.values?.[0]?.value?.includes('fetch') ||
        event.exception?.values?.[0]?.value?.includes('Failed to fetch'))
    ) {
      return null;
    }

    // Filter out script loading errors
    if (event.exception?.values?.[0]?.value?.includes('Loading chunk')) {
      return null;
    }

    return event;
  },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
